import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Seo from '../../components/Seo';
import ITTrainingHeader from '../../components/ITTrainingHeader';
import ITTrainingFooter from '../../components/ITTrainingFooter';
import { nonProgrammingCourses } from '../../data/courseData';

// Map course title → slug for detail page links
const titleToSlug = {
  'Web Design Training':           'web-design-training',
  'Graphics Design Training':      'graphics-design-training',
  'SEO Training':                  'seo-training',
  'Digital Marketing':             'digital-marketing-nonprog',
  'Business Development Training': 'business-development-training',
};

// Topic accordion
function AccordionTopic({ topic }) {
  const [open, setOpen] = useState(false);
  return (
    <li className="itpage-accord-item">
      <button
        className={open ? 'itpage-accord-btn itpage-accord-btn--open' : 'itpage-accord-btn'}
        onClick={() => setOpen(v => !v)}
        type="button"
      >
        <span>{topic.name}</span>
        <span className="itpage-accord-caret">{open ? '▴' : '▾'}</span>
      </button>
      {open && <p className="itpage-accord-detail">{topic.detail}</p>}
    </li>
  );
}

function NonProgrammingCourses() {
  return (
    <div className="itp-shell">
      <Seo
        title="Non-Programming Courses | Web Design, Digital Marketing, SEO Training | Vedanskrix"
        description="Learn web design, graphics design, digital marketing, SEO at Vedanskrix Ahmedabad. Non-programming IT courses with practical training."
        keywords={['web design course','graphics design training','digital marketing course','SEO training','Adobe Photoshop course','responsive design course','social media marketing','online marketing course','non-programming IT courses Ahmedabad']}
      />
      <ITTrainingHeader />

      {/* Hero */}
      <section className="itpage-hero itpage-hero--nonprog">
        <div className="itpage-hero__overlay" />
        <div className="itp-container itpage-hero__content">
          <p className="itpage-hero__eyebrow">Vedanskrix IT Training</p>
          <h1 className="itpage-hero__title">Non-Programming Courses</h1>
          <p className="itpage-hero__sub">Design, marketing &amp; business skills for a complete digital career</p>
          <div className="itpage-hero__crumb">
            <Link to="/">Home</Link>
            <span> › </span>
            <span>Non-Programming Courses</span>
          </div>
        </div>
      </section>

      {/* Categories */}
      <section className="itpage-section">
        <div className="itp-container">
          <div className="itpage-section-head">
            <span className="itpage-section-tag">{nonProgrammingCourses.length} Course Categories</span>
            <h2 className="itpage-section-title">Design, Marketing &amp; Beyond</h2>
            <p className="itpage-section-sub">
              Practical, industry-focused training that gets you job-ready without writing a single line of code.
            </p>
          </div>

          <div className="itpage-np-grid">
            {nonProgrammingCourses.map((cat) => {
              const slug = titleToSlug[cat.title] || cat.slug;
              return (
                <div key={cat.title} className="itpage-np-card" style={{'--cat-color': cat.color || '#e74c3c'}}>
                  <div className="itpage-np-card__head">
                    <span className="itpage-np-card__icon">{cat.icon}</span>
                    <div>
                      <h3 className="itpage-np-card__title">{cat.title}</h3>
                      <div className="itpage-np-card__badges">
                        <span className="itpage-course-card__badge itpage-course-card__badge--duration">⏱ {cat.duration}</span>
                        <span className="itpage-course-card__badge itpage-course-card__badge--level">🎯 {cat.level}</span>
                      </div>
                    </div>
                  </div>
                  <p className="itpage-np-card__desc">{cat.desc || cat.description}</p>

                  {/* Topics accordion */}
                  {cat.topics && cat.topics.length > 0 && (
                    <ul className="itpage-accord-list">
                      {cat.topics.map(t => <AccordionTopic key={t.name} topic={t} />)}
                    </ul>
                  )}

                  {/* Curriculum topics from courseData (if no topics field) */}
                  {!cat.topics && cat.curriculum && (
                    <ul className="itpage-accord-list">
                      {cat.curriculum.flatMap(ph => ph.items).slice(0, 4).map(item => (
                        <li key={item} className="itpage-accord-item" style={{padding: '6px 0', fontSize: '0.87rem', color: '#444'}}>
                          <span style={{color:'#27ae60', marginRight: '8px'}}>✔</span>{item}
                        </li>
                      ))}
                    </ul>
                  )}

                  <div className="itpage-course-card__actions" style={{marginTop: '16px'}}>
                    <Link to={`/course/${slug}`} className="itpage-course-card__btn">View Course →</Link>
                    <Link to="/contact" className="itpage-course-card__btn itpage-course-card__btn--outline">Enquire</Link>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="itpage-cta-strip">
        <div className="itp-container itpage-cta-strip__inner">
          <div>
            <h3 className="itpage-cta-strip__title">Ready to build your creative career?</h3>
            <p className="itpage-cta-strip__sub">Talk to our counsellors and find the perfect course for you.</p>
          </div>
          <Link to="/contact" className="itpage-cta-strip__btn">Get Free Counselling →</Link>
        </div>
      </section>

      <ITTrainingFooter />
    </div>
  );
}

export default NonProgrammingCourses;
